import { AccountType } from "../../../../shared/types/accounts";
import { findAccountByIdentity } from "../../../../entities/accounts/libs/account-identity";

/**
 * Whether a Facebook Page or Group Facebook has just offered is already
 * connected. Id only, per the account identity rule: a Page or Group name is a
 * display title that two can share. Page and Group pickers share this, and
 * neither distinguishes Page rows from Group rows.
 */
export function isFacebookTargetAlreadyAdded(
  target: { id: string },
  existingAccounts: AccountType[]
): boolean {
  return Boolean(
    findAccountByIdentity(existingAccounts, {
      platformType: "FB",
      ids: [target.id],
    })
  );
}
